import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

function ToastError({ props }) {
  const { open, response, onError, other } = props;
  const [visible, setVisible] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (open === true) {
      setVisible(true);
    }
  }, [open]);

  return (
    <Modal
      title={null}
      visible={visible}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={350}
    >
      <div>
        <div className="flex justify-center">
          <div>
            <p className="header-title-semi colors-blue text-2xl mb-3 text-center font-semibold">
              Terjadi Kesalahan
            </p>

            <div className="flex justify-center">
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "/assets/icon/ic_error_modal.svg"
                }
                alt="icon-error"
                className="my-6"
              />
            </div>

            <p className="header-content colors-gray text-base text-center">
              {response.length > 0
                ? response
                : "Mohon maaf sistem kami sedang terjadi kesalahan, silahkan coba lagi nanti"}
            </p>
          </div>
        </div>
        <div>
          {!other ? (
            <button
              onClick={() => {
                setVisible(false);
                onError();
              }}
              className="btn-blue w-full p-3 mt-8 focus:outline-none"
            >
              <div className="text-white lg:text-lg">Kembali ke Sebelumnya</div>
            </button>
          ) : (
            <button
              onClick={() => {
                setVisible(false);
                onError();
                history.push("/profile");
              }}
              className="btn-blue w-full p-3 mt-8 focus:outline-none"
            >
              <div className="text-white lg:text-lg">Lengkapi Profile</div>
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ToastError;
